module.exports = __webpack_public_path__ + "static/img/tiggy_pictgrid35_960x854.9b7b0a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/tiggy_pictgrid35_960x854.jpg
// module id = yTun
// module chunks = 0